import React from "react";
import Footer from "../common/Footer";
import Header from "../common/Header";
import PPPHeroSection from "./PPPHeroSection";
import PPPStrategySection from "./PPPStrategySection";
import PPPDomainsSection from "./PPPDomainsSection";
import PPPRoleSection from "./PPPRoleSection";
import PPPWhyPartnerSection from "./PPPWhyPartnerSection";
import PPPBackground from "../../Images/services-bg.webp";

const PPPage = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <section
        className={`relative w-full h-auto bg-cover bg-no-repeat bg-top bg-black`}
        style={{
          backgroundImage: `url(${PPPBackground})`,
          backgroundAttachment: 'scroll'
        }}
      >
        <PPPHeroSection />
        <PPPStrategySection />
        <PPPDomainsSection />
        <PPPRoleSection />
        <PPPWhyPartnerSection />
      </section>
      <Footer />
    </div>
  );
};

export default PPPage;
